// CNS OBJECT EXTENSION
// FOR MODALS
;(({ $ }) => {
    const page = $('#page')
    const overlay = $('#overlay')

    const pageLockedClass = 'page--locked'
    const overlayShownClass = 'overlay--shown'
    const modalShownClass = 'modal--shown'
    const triggerActiveClass = 'trigger--active'

    CNS.$modals.shownModals = {
        selectors: [],
        triggers: []
    }

    const openModal = (selector, trigger, showOverlay = false, lockPage = false, zOverlay = 90, callbackBefore = null, callbackAfter = null) => {
        const modal = $(selector)

        if (typeof callbackBefore == 'function') {
            callbackBefore(modal, trigger, overlay)
        }

        if (modal) {
            modal.classList.add(modalShownClass)
            CNS.$modals?.shownModals?.selectors?.push(selector)
        }

        if (lockPage && page) {
            page.classList.add(pageLockedClass)
        }

        if (showOverlay && overlay) {
            overlay.classList.add(overlayShownClass)
            overlay.style.zIndex = zOverlay
        }

        if (trigger) {
            trigger.classList.add(triggerActiveClass)
            CNS.$modals?.shownModals?.triggers?.push(trigger)
        }

        if (typeof callbackAfter == 'function') {
            callbackAfter(modal, trigger, overlay)
        }
    }

    const closeModal = (selector, trigger, callbackBefore = null, callbackAfter = null, closeOverlay = true) => {
        const modal = $(selector)

        if (typeof callbackBefore == 'function') {
            callbackBefore(modal, trigger, overlay)
        }

        if (modal) {
            modal.classList.remove(modalShownClass)
            CNS.$modals.shownModals.selectors = CNS.$modals?.shownModals?.selectors.filter(el => el != selector)
        }

        if (page) {
            page.classList.remove(pageLockedClass)
        }

        if (overlay && closeOverlay) {
            overlay.classList.remove(overlayShownClass)
        }

        if (trigger) {
            trigger.classList.remove(triggerActiveClass)
            CNS.$modals.shownModals.triggers = CNS.$modals.shownModals.triggers.filter(el => el != trigger)
        }

        if (typeof callbackAfter == 'function') {
            callbackAfter(modal, trigger, overlay)
        }
    }

    const closeAllModals = (callbackBefore = null, callbackAfter = null) => {
        if (typeof callbackBefore == 'function') {
            callbackBefore(null, null, overlay)
        }

        const clonedSelectors = [...CNS.$modals.shownModals.selectors]
        clonedSelectors.forEach(selector => closeModal(selector))

        CNS.$modals.shownModals.triggers.forEach(trigger => trigger.classList.remove(triggerActiveClass))

        CNS.$modals.shownModals = {
            selectors: [],
            triggers: []
        }

        if (page) {
            page.classList.remove(pageLockedClass)
        }

        if (overlay) {
            overlay.classList.remove(overlayShownClass)
        }

        if (typeof callbackAfter == 'function') {
            callbackAfter(null, null, overlay)
        }
    }

    if (overlay) {
        overlay.addEventListener('click', () => closeAllModals())
    }

    CNS.$modals.openModal = openModal
    CNS.$modals.closeModal = closeModal
    CNS.$modals.closeAllModals = closeAllModals
})(CNS)
;(({ $, $$ }) => {
    const page = $('#page')
    const pageNoTopMarginClass = 'page--no-top-margin'

    // Touch Panel
    const burger = $('#touch-panel-trigger')

    CNS.$fns.openTouchPanel = () => {
        CNS.$modals.closeAllModals()
        page.classList.add(pageNoTopMarginClass)
        CNS.$modals.openModal('#touch-panel', burger, false, true)
    }

    CNS.$fns.closeTouchPanel = () => {
        CNS.$modals.closeModal('#touch-panel', burger)
        page.classList.remove(pageNoTopMarginClass)
    }

    if (burger) {
        burger.addEventListener('click', () => {
            if (burger.classList.contains('trigger--active')) {
                // close the touch panel
                CNS.$fns.closeTouchPanel()
            } else {
                // open the touch panel
                CNS.$fns.openTouchPanel()
            }
        })
    }

    // Login modal
    CNS.$fns.openLoginModal = (trigger) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-login', trigger, true, true)
    }

    CNS.$fns.closeLoginModal = (trigger) => {
        CNS.$modals.closeModal('#modal-login', trigger)
    }

    const loginModalOpenTriggers = $$('.modal-login-open-trigger')
    const loginModalCloseTriggers = $$('.modal-login-close-trigger')

    loginModalOpenTriggers.forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.openLoginModal(t)
        })
    })

    loginModalCloseTriggers.forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.closeLoginModal(t)
        })
    })

    // Verification sent
    CNS.$fns.openVerificationSentModal = (trigger) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-verification-sent', trigger, true, true)
    }

    CNS.$fns.closeVerificationSentModal = (trigger) => {
        CNS.$modals.closeModal('#modal-verification-sent', trigger)
    }

    $$('.modal-verification-sent-close-trigger').forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.closeVerificationSentModal(t)
        })
    })

    // Verification done
    CNS.$fns.openVerificationDoneModal = (trigger) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-verification-done', trigger, true, true)
    }

    CNS.$fns.closeVerificationDoneModal = (trigger) => {
        CNS.$modals.closeModal('#modal-verification-done', trigger)
    }

    $$('.modal-verification-done-close-trigger').forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.closeVerificationDoneModal(t)
        })
    })

    // Password changed
    CNS.$fns.openPasswordChangedModal = (trigger) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-password-changed', trigger, true, true)
    }

    CNS.$fns.closePasswordChangedModal = (trigger) => {
        CNS.$modals.closeModal('#modal-password-changed', trigger)
    }

    $$('.modal-password-changed-close-trigger').forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.closePasswordChangedModal(t)
        })
    })

    // Reset password
    CNS.$fns.openResetPasswordModal = (trigger) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-reset-password', trigger, true, true)
    }

    CNS.$fns.closeResetPasswordModal = (trigger) => {
        CNS.$modals.closeModal('#modal-reset-password', trigger)
    }

    $$('.modal-reset-password-close-trigger').forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.closeResetPasswordModal(t)
        })
    })

    // Reset password sent
    CNS.$fns.openResetPasswordLinkSentModal = (trigger) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-reset-pass-link-sent', trigger, true, true)
    }

    CNS.$fns.closeResetPasswordLinkSentModal = (trigger) => {
        CNS.$modals.closeModal('#modal-reset-pass-link-sent', trigger)
    }

    $$('.modal-reset-pass-link-sent-close-trigger').forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.closeResetPasswordLinkSentModal(t)
        })
    })

    // All tags
    CNS.$fns.openAllTagsModal = (trigger) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-all-tags', trigger, true, true)
    }

    CNS.$fns.closeAllTagsModal = (trigger) => {
        CNS.$modals.closeModal('#modal-all-tags', trigger)
    }

    $$('.modal-all-tags-close-trigger').forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.closeAllTagsModal(t)
        })
    })

    // Vote modal
    CNS.$fns.openVoteModal = (trigger) => {
        const serverId = trigger.getAttribute('data-server-id');

        if (serverId) {
            const modal = document.querySelector('#modal-vote-done')
            const inputServer =  modal.querySelector('[data-server-id]');

            inputServer.value = serverId
            inputServer.dispatchEvent(new Event('input'))
        }

        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-vote', trigger, true, true)
    }

    CNS.$fns.closeVoteModal = (trigger) => {
        CNS.$modals.closeModal('#modal-vote', trigger)
    }

    const modalVoteCloseTriggers = $$('.modal-vote-close-trigger')

    modalVoteCloseTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            CNS.$fns.closeVoteModal(trigger)
        })
    })

    // Vote done
    CNS.$fns.openVoteDoneModal = (trigger) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-vote-done', trigger, true, true)
    }

    CNS.$fns.closeVoteDoneModal = (trigger) => {
        CNS.$modals.closeModal('#modal-vote-done', trigger)
    }

    $$('.modal-vote-done-close-trigger').forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.closeVoteDoneModal(t)
        })
    })

    // Avatar upload
    CNS.$fns.openAvatarUploadModal = (trigger) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#modal-avatar-upload', trigger, true, true)
    }

    CNS.$fns.closeAvatarUploadModal = (trigger) => {
        CNS.$modals.closeModal('#modal-avatar-upload', trigger)
    }

    $$('.modal-avatar-upload-open-trigger').forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.openAvatarUploadModal(t)
        })
    })

    $$('.modal-avatar-upload-close-trigger').forEach(t => {
        t.addEventListener('click', () => {
            CNS.$fns.closeAvatarUploadModal(t)
        })
    })

})(CNS)
